<template>
  <div :id="pageComponent.uuid"
       :ref="pageComponent.uuid"
       :data-type="pageComponent.properties.element_type"
       :class="customClasses"
       :style="mapCssProperties"
       @pointerdown="resetIdle">

    <kiosk-elements v-for="element in pageComponent.parent_elements" :key="element.uuid"
      :element="element"
      :kioskProperties="kioskProperties"
      :session-uuid="whichSessionUuid()" />

    <kiosk-child-components v-for="component in pageComponent.children" :key="component.uuid"
      :component="component"
      :parentComponent="pageComponent"
      :kioskProperties="kioskProperties"
      :session-uuid="whichSessionUuid()" />
  </div>
</template>

<script>
import HelperMethods from '../mixins/helper_methods';
import OrderingHelper from '../mixins/ordering_helper';
import ComponentEventHelper from '../mixins/component_event_helper';

export default {
  name: 'KioskBoundingBoxRoot',
  mixins: [HelperMethods, OrderingHelper, ComponentEventHelper],
  components: {
    KioskElements: () => import('../elements/kiosk-elements.vue'),
    KioskChildComponents: () => import('./kiosk-child-components.vue'),
  },
  props: {
    pageComponent: Object,
    parentComponent: Object,
    kioskProperties: Object,
    parentSessionUuid: {
      type: String,
      default: null,
    },
    childSessionUuid: {
      type: String,
      default: null,
    },
  },
  watch: {
    parentSessionUuid() {
      this.sessionUuid = this.parentSessionUuid;
    },
  },
  data() {
    return {
      properties: this.pageComponent.properties,
      idleTimer: null,
      idleTimerCount: 0,
      enableIdleTimer: false,
    };
  },
  created() {
    // here we're checking for the dile timer of when it begins
    if (this.properties) {
      if (this.properties.session_root === true && this.properties.enable_idle_timer) {
        this.enableIdleTimer = true;
        this.startIdleTimer();
      }
    }
  },
  mounted() {
    const rootContainer = this.$refs[this.pageComponent.uuid];
    if (this.parentSessionUuid) {
      rootContainer.addEventListener('click', this.setupClick);
    }
  },
  beforeDestroy() {
    const rootContainer = this.$refs[this.pageComponent.uuid];
    rootContainer.removeEventListener('click');
    this.clearIdleTimer();
  },
  methods: {
    setupClick(e) {
      e.preventDefault();
      // get the right target for its instance
      const target = (e.target.id) ? e.target : e.target.parentNode;
      let targetName = target.id;
      if (target && target.name) {
        targetName = target.name;
      }
      const eventData = {
        id: target.id,
        type: 'User Interacted',
        name: targetName,
        target_type: null,
        userAction: true,
        uuid: target.id,
      };
      // find the object that we are searching for to trigger the event.
      const object = this.searchInRootForElementOrComponent(target.id);
      if (object && object.properties) {
        eventData.name = object.name;
        eventData.target_type = object.properties.element_type;
        if (eventData.uuid === null) {
          eventData.uuid = object.uuid;
        }
        this.debugClicks(eventData);
      }
      // determine the event type to start using its event sequence
      if (object && object.properties && object.properties.events) {
        if (object.properties.button_sound) {
          const audio = new Audio(object.properties.button_sound);
          if (audio) audio.play();
        }
        // setup events
        const objectEvents = object.properties.events;
        objectEvents.forEach((event) => {
          this.$eventHub.$emit(object.element.uuid, event);
        });
      }
      this.fireEventRecorder(eventData, true, this.whichSessionUuid());
    },
    startIdleTimer() {
      if (this.enableIdleTimer) {
        this.idleTimer = setInterval(() => {
          this.executeIdleTimer();
        }, 1000);
      }
    },
    executeIdleTimer() {
      if (this.enableIdleTimer) {
        this.idleTimerCount += 1;
        // console.log(`idle tick ${this.sessionUuid}`, this.idleTimerCount);
        if (this.idleTimerCount > this.properties.session_idle_timeout) {
          this.idleTimerTimeout();
        }
      } else {
        this.clearIdleTimer();
      }
    },
    idleTimerTimeout() {
      // this.sendEvents(this.properties.session_timeout_events);
    },
    clearIdleTimer() {
      clearInterval(this.idleTimer);
      this.idleTimerCount = 0;
      this.idletimer = 0;
    },
    resetIdle() {
      // event.stopPropagation();
      if (this.enableIdleTimer === true) {
        this.idleTimerCount = 0;
        // console.log(`resetIdle trigger ${this.pageComponent.uuid}`);
      }
    },
    whichSessionUuid() {
      // checking to create session based on where the bounding root box is
      if (this.parentSessionUuid === null) {
        return this.childSessionUuid;
      }
      return this.parentSessionUuid;
    },
    /**
     * Attempts to search in root to find the issue
     */
    searchInRootForElementOrComponent(uuid, parent = this.$root) {
      let value = null;

      if (parent.$refs[uuid]) return parent;

      // iterate through to find the child
      for (let i = 0; i < parent.$children.length; i += 1) {
        const child = parent.$children[i];
        // check
        if (child.$refs[uuid]) {
          value = child;
          break;
        }

        if (child.$children.length > 0) value = this.searchInRootForElementOrComponent(uuid, child);

        if (value) break;
      }

      return value;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
